<template>
  <el-footer class="me-area">
    <div class="me-footer">
      <p>Designed by
        <strong>
          <router-link to="/" class="me-login-design-color">ForFun</router-link>
        </strong>
        <span style="font-size: 14px;margin-left: 40px">
        ©{{year}} <span>史明辉 | <a target="_blank" href="https://beian.miit.gov.cn">鲁ICP备19013678号</a> </span>
        </span>
        <span style="margin-left: 40px">
          >>>
          <a target="_blank" href="http://www.shiminghui.top" class="me-login-design-color">Blog</a>
          <span class="me-login-design-color">|</span>
          <a target="_blank" href="http://search.shiminghui.top" class="me-login-design-color">Home</a>
          <<<
        </span>
      </p>

    </div>
  </el-footer>

</template>

<script>

  export default {
    name: 'BaseFooter',
    data() {
      return {
        year: new Date().getFullYear()
      }
    },
    methods: {},
    mounted() {
    }
  }
</script>

<style>

  .el-footer {
    min-width: 100%;
    box-shadow: 0 -2px 3px hsla(0, 0%, 7%, .1), 0 0 0 1px hsla(0, 0%, 7%, .1);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1024;
  }

  .me-footer {
    text-align: center;
    line-height: 60px;
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;

  }

  .me-login-design-color {
    color: #5FB878 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/BaseFooter.vue